import React from 'react'
import { useRecoilValue } from 'recoil'
import { analyticData } from '../../../recoil/analytic'
import CountQuestion from './CountQuestion'
import CountUser from './CountUser'
import MostCorrect from './MostCorrect'
import MostWrong from './MostWrong'

const Conclution = ({clickQuiz}) => {
  const analytic = useRecoilValue(analyticData);

  return (
    <div>
      <h4 className="mb-2 text-slate-400">Kesimpulan</h4>
      <div className="flex gap-5 text-slate-400">
        <div className="w-1/4">
          <CountQuestion number={analytic.count_questions}/>
          <CountUser number={analytic.count_users}/>
        </div>
        <div className="w-3/4">
          <MostCorrect list={analytic.most_correct} clickQuiz={clickQuiz}/>
          <MostWrong list={analytic.most_wrong} clickQuiz={clickQuiz}/>
        </div>
      </div>
    </div>
  )
}

export default Conclution